import React from 'react';

const HeroSection = () => {
  const [lightbox, setLightbox] = React.useState(null);

  return (
    <div style={{ color: '#111827' }}>
      {/* ✅ MOBILE RESPONSIVE CSS */}
      <style>{`
        @media (max-width: 768px) {
          .preview-section {
            padding: 24px !important;
          }
          .preview-title {
            font-size: 20px !important;
          }
          .preview-text {
            font-size: 15px !important;
          }
          .study-modes-grid {
            grid-template-columns: 1fr !important;
          }
        }
        
        @media (max-width: 480px) {
          .preview-section {
            padding: 16px !important;
          }
          .preview-title {
            font-size: 18px !important;
          }
        }
      `}</style>

      {/* Study Modes Section */}
      

      {/* Product Preview Section */}
      <div
        className="preview-section"
        style={{
         // backgroundColor: '#fbedd8ff',
          backgroundColor: '#ffffff',
          padding: '40px',
          borderRadius: '12px',
          border: '1px solid rgba(0,0,0,0.1)',
          marginBottom: '18px',
          textAlign: 'left',
          boxShadow: '0 6px 20px rgba(0,0,0,0.1)',
        }}
      >
        <h3
          className="preview-title"
          style={{
            fontSize: '26px',
            fontWeight: '700',
            marginBottom: '16px',
            color: '#000000',
          }}
        >
          Experience the Platform
        </h3>

   <p
  className="preview-text"
  style={{
    fontSize: '17px',
    color: '#000000',
    marginBottom: '36px',
    lineHeight: '1.7',
  }}
>
  Explore realistic Java exam simulations, instant feedback, and detailed mistake
  reviews — all in an exam-style interface designed to help you master{' '}
  <strong>Java SE 17 OCP (1Z0-829)</strong> and <strong>Java SE 21 OCP (1Z0-830)</strong>{' '}
  certifications with confidence.{' '}
  <span style={{ color: '#121212ff', fontWeight: 'bold' }}>
    Click on each image to see a bigger preview.
  </span>
</p>

        {/* Image Scroll Container */}
        <div style={{ position: 'relative', overflow: 'hidden', marginTop: '30px' }}>
          <div
            id="imageScroll"
            style={{
              display: 'flex',
              gap: '20px',
              overflowX: 'auto',
              scrollBehavior: 'smooth',
              paddingBottom: '10px',
            }}
          >
            {[
              {
                src: 'https://s3.us-east-1.amazonaws.com/javaocp.clustermicro.com/afterlogin.png',
                alt: 'after login from homepage',
              },
              {
                src: 'https://s3.us-east-1.amazonaws.com/javaocp.clustermicro.com/test.png',
                alt: 'Exam Interface',
              },
              {
                src: 'https://s3.us-east-1.amazonaws.com/javaocp.clustermicro.com/reviewmistakes.png',
                alt: 'Mistake Review',
              },
                {
                src: 'https://s3.us-east-1.amazonaws.com/javaocp.clustermicro.com/history.png',
                alt: 'history page',
              },
                {
                src: 'https://s3.us-east-1.amazonaws.com/javaocp.clustermicro.com/explanation.png',
                alt: 'Explanation',
              },
                 {
                src: 'https://s3.us-east-1.amazonaws.com/javaocp.clustermicro.com/examresult.png',
                alt: 'Exam Result page',
              },
            ].map((img, idx) => (
              <img
                key={idx}
                src={img.src}
                alt={img.alt}
                onClick={() => setLightbox(img.src)}
                style={{
                  flex: '0 0 auto',
                  width: '44%',
                  // padding: '40px 40px 50px 40px',
                  maxWidth: '300px',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,0,0,0.1)',
                  boxShadow: '0 6px 20px rgba(0,0,0,0.1)',
                  cursor: 'pointer',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'scale(1.02)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.2)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.1)';
                }}
              />
            ))}
          </div>

          {/* Scroll Buttons */}
          <button
            onClick={() => {
              document.getElementById('imageScroll').scrollBy({ left: -400, behavior: 'smooth' });
            }}
            style={{
              position: 'absolute',
              top: '50%',
              left: '10px',
              transform: 'translateY(-50%)',
              backgroundColor: 'rgba(255,255,255,0.9)',
              border: 'none',
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
              cursor: 'pointer',
              fontSize: '18px',
              fontWeight: 'bold',
            }}
          >
            ‹
          </button>

          <button
            onClick={() => {
              document.getElementById('imageScroll').scrollBy({ left: 400, behavior: 'smooth' });
            }}
            style={{
              position: 'absolute',
              top: '50%',
              right: '10px',
              transform: 'translateY(-50%)',
              backgroundColor: 'rgba(255,255,255,0.9)',
              border: 'none',
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
              cursor: 'pointer',
              fontSize: '18px',
              fontWeight: 'bold',
            }}
          >
            ›
          </button>
        </div>

        {/* Lightbox overlay */}
        {lightbox && (
          <div
            onClick={() => setLightbox(null)}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0,0,0,0.85)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000,
              cursor: 'zoom-out',
            }}
          >
            <img
              src={lightbox}
              alt="Enlarged preview"
              style={{
                maxWidth: '92%',
                maxHeight: '92%',
                borderRadius: '10px',
                boxShadow: '0 0 25px rgba(255,255,255,0.3)',
              }}
            />
          </div>
        )}
      </div>

      {/* Our Comprehensive Practice Platform */}
      <div
        style={{
          //backgroundColor: '#fbedd8ff',
          backgroundColor: '#ffffff',
          padding: '32px',
          borderRadius: '12px',
          marginBottom: '18px',
          border: '1px solid rgba(0,0,0,0.1)',
          boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
        }}
      >
        <h3
          style={{
            fontSize: '22px',
            fontWeight: '700',
            marginBottom: '20px',
            color: '#000000',
          }}
        >
          Our Comprehensive Practice Platform
        </h3>

        <ul style={{
  fontSize: '15px',
  lineHeight: '1.8',
  color: '#374151',
  paddingLeft: '20px',
  margin: 0
}}>
  <li>Full-length realistic exams for both Java 17 & 21</li>
  <li><strong>1,884 Java 17 questions and 2,074 Java 21 questions</strong>, with significant cross-version coverage</li>
  <li>Performance analytics showing where to focus your study</li>
  <li>Unlimited attempts for 6 months to build exam confidence</li>
  <li>Version selector to practice for either or both certifications</li>
</ul> 

        <p style={{
          fontSize: '16px',
          marginTop: '24px',
          padding: '16px',
          // backgroundColor: '#DEE3EB',
          borderRadius: '8px',
          fontWeight: '500',
          backgroundColor: '#777777',
          color: '#FFFF00',
          margin: '24px 0 0 0'
        }}>
          Ready to become Certified? Create your account and start practicing today! 
        </p>
      </div>

      {/* Contact Us */}
  {/* Contact Us + Trademark */}
{/* <div style={{
  backgroundColor: '#fbedd8ff',
  padding: '24px',
  borderRadius: '12px',
  border: '1px solid rgba(0,0,0,0.1)',
  boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
  textAlign: 'center',
}}>
  <p style={{
    fontSize: '15px',
    color: '#374151',
    margin: '0 0 16px 0'
  }}>
    Contact us at: <strong>ab.clustermicro@gmail.com</strong>
  </p>
  <p style={{
    fontSize: '11px',
    color: '#9ca3af',
    margin: 0,
    lineHeight: '1.5'
  }}>
    Java® and Oracle Certified Professional (OCP)® are registered trademarks of Oracle Corporation. 
    This website is not affiliated with or endorsed by Oracle.
  </p>
</div> */}

{/* Contact Us + Policy Links + Trademark */}
<div style={{
  backgroundColor: '#ffffffff',
  padding: '24px',
  borderRadius: '12px',
  border: '1px solid rgba(0,0,0,0.1)',
  boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
  textAlign: 'center',
}}>
  <p style={{
    fontSize: '15px',
    color: '#374151',
    margin: '0 0 16px 0'
  }}>
    Contact us at: <strong>ab.clustermicro@gmail.com</strong>
  </p>
  
  {/* Policy Links */}
  <div style={{
    display: 'flex',
    gap: '16px',
    justifyContent: 'center',
    flexWrap: 'wrap',
    margin: '16px 0',
    padding: '12px 0',
    borderTop: '1px solid rgba(0,0,0,0.1)',
    borderBottom: '1px solid rgba(0,0,0,0.1)'
  }}>
    <a 
      href="/terms.html" 
      style={{
        fontSize: '13px', 
        color: '#667eea',
        textDecoration: 'none',
        fontWeight: '500'
      }}
      onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
      onMouseOut={(e) => e.target.style.textDecoration = 'none'}
    >
      Terms & Conditions
    </a>
    <span style={{color: '#9ca3af'}}>•</span>
    <a 
      href="/privacy.html" 
      style={{
        fontSize: '13px', 
        color: '#667eea',
        textDecoration: 'none',
        fontWeight: '500'
      }}
      onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
      onMouseOut={(e) => e.target.style.textDecoration = 'none'}
    >
      Privacy Policy
    </a>
    <span style={{color: '#9ca3af'}}>•</span>
    <a 
      href="/shipping.html" 
      style={{
        fontSize: '13px', 
        color: '#667eea',
        textDecoration: 'none',
        fontWeight: '500'
      }}
      onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
      onMouseOut={(e) => e.target.style.textDecoration = 'none'}
    >
      Shipping & Delivery
    </a>
    <span style={{color: '#9ca3af'}}>•</span>
    <a 
      href="/refund.html" 
      style={{
        fontSize: '13px', 
        color: '#667eea',
        textDecoration: 'none',
        fontWeight: '500'
      }}
      onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
      onMouseOut={(e) => e.target.style.textDecoration = 'none'}
    >
      Refund Policy
    </a>
    <span style={{color: '#9ca3af'}}>•</span>
    <a 
      href="/contact.html" 
      style={{
        fontSize: '13px', 
        color: '#667eea',
        textDecoration: 'none',
        fontWeight: '500'
      }}
      onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
      onMouseOut={(e) => e.target.style.textDecoration = 'none'}
    >
      Contact Us
    </a>
  </div>
  
<p style={{
  fontSize: '11px',
  color: '#9ca3af',
  margin: 0,
  lineHeight: '1.5'
}}>
  Java® and Oracle Certified Professional (OCP)® are registered trademarks of Oracle Corporation. 
  This website is not affiliated with or endorsed by Oracle.
</p>
</div>
    </div>
  );
};

export default HeroSection;